import { subject } from '@casl/ability'

import { Button, BUTTON_TYPES } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { ReactComponent as Send16 } from 'assets/svg/Send16.svg'
import { useRFPDetailsActions } from 'features/RFP/RFPDetails/Providers/RFPDetailsActionsProvider'
import { Can, ACTIONS, SUBJECTS } from 'features/Permission'
import { useRFPDetailsContext } from 'features/RFP/RFPDetails/Providers/RFPDetailsContextProvider'

export default () => {
  const rfpDetailsContext = useRFPDetailsContext()
  const rfpDetailsActions = useRFPDetailsActions()

  const { data } = rfpDetailsContext.state

  return (
    <Can I={ACTIONS.SEND} a={subject(SUBJECTS.SURVEY, { ...data })}>
      <Button
        icon={<Send16 />}
        type={BUTTON_TYPES.PRIMARY}
        onClick={rfpDetailsActions.handleSendSurvey}
        upperCase
      >
        {BTN_TXT.SEND_SURVEY}
      </Button>
    </Can>
  )
}
